@if (breakpointChanges$ | async; as isLtMdScreen) {
  @if (isLtMdScreen.matches) {
    <ng-content />
  }
}
